import { useMemo } from 'react'
import { filterAssignableRoles } from '../../modules/ac/assignableRoles'
import useRoles from './useRoles'

const roleToSelectOption = ({ id, name }) => ({
  value: id,
  label: name
})

const useRolesAsSelectOptions = () => {
  const roles = useRoles()

  return useMemo(
    () => filterAssignableRoles(roles).map(roleToSelectOption),
    [roles]
  )
}

export default useRolesAsSelectOptions
